class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.flickity = null;
    this.total = this.getAttribute("total");
    this.initGallery();
    this.setupEventListeners();
    this.initProductTabs();
    this.replaceDescStars();
  }

  setupEventListeners() {
    const thumbs = this.querySelectorAll(".product-gallery__thumb");
    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", this.onThumbClick(thumb).bind(this));
    });
    const prev = this.querySelector(".product-gallery__thumbs-prev");
    if (prev) {
      prev.addEventListener("click", this.onPrev.bind(this));
    }
    const next = this.querySelector(".product-gallery__thumbs-next");
    if (next) {
      next.addEventListener("click", this.onNext.bind(this));
    }
    const $galPrev = this.querySelector(".carousel-prev button");
    $galPrev.addEventListener("click", this.onPrev.bind(this));
    const $galNext = this.querySelector(".carousel-next button");
    $galNext.addEventListener("click", this.onNext.bind(this));
  }

  initGallery() {
    const options = {
      draggable: true,
      wrapAround: true,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: true,
    };
    const gallery = this.querySelector(".product-gallery");
    if (matchMedia("screen and (min-width: 1024px)").matches) {
      options.wrapAround = false;
      options.draggable = false;
      options.pageDots = false;
      options.fade = true;
    }
    this.flickity = new Flickity(gallery, options);
  }

  onThumbClick(item) {
    return (e) => {
      const idx = Array.from(item.parentNode.children).indexOf(item);
      Array.from(item.parentNode.children).forEach((item) =>
        item.classList.remove("active")
      );
      item.classList.add("active");
      this.flickity.select(idx);
    };
  }

  updateThumb(direction) {
    const idx = this.flickity.selectedIndex;
    const total = Number(this.total);
    const last = total - 4;
    const next = idx + 1 === total ? 0 : idx + 1;
    const prev = idx - 1 === -1 ? total - 1 : idx - 1;
    const $next = direction === "inc" ? next : prev;
    const anim = this.querySelector(".product-gallery__thumbs-anim");

    if (total > 4) {
      const transform = $next * 80 > last * 80 ? last * 80 : $next * 80;
      anim.style.transform = `translateY(-${transform}px)`;
    }

    anim.querySelector(".active").classList.remove("active");
    anim.children[$next].classList.add("active");
    this.flickity.select($next);
  }

  onNext() {
    this.updateThumb("inc");
  }

  onPrev() {
    this.updateThumb("dec");
  }

  initProductTabs() {
    this.querySelectorAll(".product-tabs__nav-item").forEach((item) => {
      item.addEventListener("click", (e) => {
        const id = e.target.id;
        this.querySelectorAll(".product-tabs__nav-item").forEach((el) =>
          el.classList.remove("active")
        );
        e.target.classList.add("active");
        this.querySelectorAll(`[data-id]`).forEach(
          (el) => (el.style.display = "none")
        );
        this.querySelector(`[data-id="${id}"]`).style.display = "block";
      });
    });
  }

  replaceDescStars() {
    const p = this.querySelectorAll(".accordion__content p").forEach((p) => {
      const html = p.innerText.replace(
        /\*/g,
        '<span class="break"></span><span class="bullet">*</span>'
      );
      p.innerHTML = html;
    });
  }
}

customElements.define("product-gallery", ProductGallery);
